define((require) => {
    "use strict";

    const $                    = require("jquery");
    const _                    = require("underscore");
    const AbstractWidgetView   = require("shared/ui/experience/widgets/AbstractWidgetView");
    const {openShareLink}      = require("shared/xp/components/widgets/socialsharing/SocialSharingService");
    const Action               = require("shared/ui/experience/action/Action");
    const Browser              = require("shared/services/Browser");
    const ViewerEvents         = require("shared/services/ViewerEvents");


    /**
     * The view rendering a social sharing widget in the Viewer.
     *
     * @class SocialSharingWidgetView
     *
     * @cfg {SocialSharingWidgetModel} model The model of the social sharing icon being rendered.
     */
    return AbstractWidgetView.extend("SocialSharingWidget", {
        // Contains share-offset css class used to adjust the sharing container in the Viewer,
        // since Editor uses a Select2 component and Viewer uses a different DOM structure.
        className: `${AbstractWidgetView.prototype.className} social-sharing-widget share-offset`,

        updateRendering(element, bounds, active) {
            element.empty();
            element.append(this._buildShareLinks(active));
        },

        /**
         * Builds the JQuery element to be added in the viewer, along with it associated click event.
         * @param {String} active - Value to used to disable clicks on thumbnails.
         * @returns {Array} shareLinkList - Array of JQuery elements to be appended in the Viewer.
         */
        _buildShareLinks(active) {
            const shareLinkList = [];

            _.each(this.model.get("networks"), function(network) {
                const $shareImage = $("<img>", {
                    src: `images/sharing/${this.model.get("style")}/${network}.png`,
                    alt: `Visit ${network}`
                });
                const $shareLink =  $("<a>", {
                    "data-network": network,
                    "class": "share-link",
                    "title": `Visit ${network}`,
                    html: $shareImage
                });

                if (this.options.enableActions) {
                    // Register click handler when inside the viewer
                    $shareLink.on("activate", (event) => { // FIXME: this should be modelled as Actions, like a LinkAction with relevant parameters
                        const shareURL = this.model.get("url");
                        // This checks that if we are on Experience Preview, we have an alert when trying to share the current URL
                        // while custom/overridden URLs will be visible in the Preview.
                        // TODO This should be generalized, since we will have to have different behaviours in Editor Preview and Viewer
                        if (!Browser.capabilities.isViewer && active) {
                            Browser.alert(Action.NOT_EMBEDDED_MESSAGE); // FIXME: this should not be in the Viewer
                        } else {
                            const currentNetwork = event.currentTarget.getAttribute("data-network");
                            openShareLink(currentNetwork, shareURL);

                            // Make sure the event follows the standard ViewerEvents format: name: (source, experienceId, descriptor)...
                            const experienceId = this._viewModel().get("experience").get("id");
                            const widgetId = this.model.has("uuid") ? this.model.get("uuid") : "";
                            ViewerEvents.trigger(ViewerEvents.SOCIAL_NETWORK_SHARE, this, experienceId, {context: network, url: shareURL, widgetId}); // TODO: consider reporting full url (a.href) and shareUrl as relative:shareUrl for consistency
                        }
                    });
                }

                shareLinkList.push($shareLink);
            }, this);

            return shareLinkList;
        }

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/socialSharingWidget/SocialSharingWidgetView.js